import React from "react";
import { Button, Modal, Progress, Typography } from "antd";
import { ClockCircleOutlined, LogoutOutlined, PoweroffOutlined } from "@ant-design/icons";

const { Text, Title } = Typography;

const SessionTimeoutAlertModal = ({
    open,
    warningDelayMinutes,
    gracePeriodMinutes,
    totalDurationMinutes,
    remainingGraceSeconds,
    gracePeriodProgress,
    onContinue,
    onLogout,
}) => {
    const remainingMinutes = Math.floor(remainingGraceSeconds / 60);
    const remainingSeconds = String(remainingGraceSeconds % 60).padStart(2, "0");

    return (
        <Modal
            open={open}
            centered
            closable={false}
            maskClosable={false}
            keyboard={false}
            width={520}
            title={null}
            footer={[
                <Button key="logout" danger icon={<LogoutOutlined />} onClick={onLogout}>
                    Déconnecter
                </Button>,
                <Button
                    key="continue"
                    type="primary"
                    icon={<ClockCircleOutlined />}
                    onClick={onContinue}
                >
                    Continuer la session
                </Button>,
            ]}
        >
            <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
                <div
                    style={{
                        borderRadius: 18,
                        padding: "18px 20px",
                        background:
                            "linear-gradient(135deg, #001529 0%, #002140 100%)",
                        color: "#fff",
                        position: "relative",
                        overflow: "hidden",
                    }}
                >
                    <div
                        style={{
                            position: "absolute",
                            top: -34,
                            right: -10,
                            width: 120,
                            height: 120,
                            borderRadius: "50%",
                            background: "rgba(255, 255, 255, 0.08)",
                        }}
                    />
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-start",
                            gap: 16,
                            position: "relative",
                        }}
                    >
                        <div style={{ flex: 1 }}>
                            <div
                                style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: 8,
                                    padding: "6px 10px",
                                    borderRadius: 999,
                                    background: "rgba(255, 255, 255, 0.12)",
                                    fontSize: 12,
                                    fontWeight: 600,
                                    letterSpacing: 0.3,
                                    marginBottom: 12,
                                }}
                            >
                                <ClockCircleOutlined />
                                Sécurité de session WebLamps
                            </div>
                            <Title level={4} style={{ margin: 0, color: "#fff" }}>
                                Session sur le point d'expirer
                            </Title>
                            <Text
                                style={{
                                    display: "block",
                                    marginTop: 8,
                                    color: "rgba(255, 255, 255, 0.88)",
                                    lineHeight: 1.7,
                                }}
                            >
                                Aucune activité n'a été détectée depuis {Math.round(warningDelayMinutes)} minutes.
                                Pour protéger l'accès à votre espace, la session sera fermée si
                                vous ne la prolongez pas dans les prochaines {Math.round(gracePeriodMinutes)} minutes.
                            </Text>
                        </div>
                        <div
                            style={{
                                width: 62,
                                height: 62,
                                borderRadius: 20,
                                background: "#ffffff",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexShrink: 0,
                            }}
                        >
                            <PoweroffOutlined
                                style={{
                                    fontSize: 28,
                                    color: "#001529",
                                }}
                            />
                        </div>
                    </div>
                </div>

                <div
                    style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: 16,
                    }}
                >
                    <div
                        style={{
                            width: 52,
                            height: 52,
                            borderRadius: 16,
                            background: "linear-gradient(135deg, #e6f4ff 0%, #bae0ff 100%)",
                            color: "#0958d9",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: 24,
                            flexShrink: 0,
                        }}
                    >
                        <ClockCircleOutlined />
                    </div>
                    <div style={{ flex: 1 }}>
                        <Title level={5} style={{ margin: 0, color: "#1f1f1f" }}>
                            Confirmation requise
                        </Title>
                        <Text style={{ display: "block", marginTop: 6, color: "#595959" }}>
                            Cliquez sur Continuer la session pour reprendre votre travail sans
                            vous reconnecter, ou choisissez Déconnecter pour fermer
                            immédiatement l'application.
                        </Text>
                    </div>
                </div>

                <div
                    style={{
                        borderRadius: 14,
                        padding: "16px 18px",
                        background: "#fafafa",
                        border: "1px solid #f0f0f0",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: 12,
                            marginBottom: 10,
                        }}
                    >
                        <Text style={{ color: "#434343", fontWeight: 600 }}>
                            Délai restant avant fermeture automatique
                        </Text>
                        <Text style={{ color: "#cf1322", fontWeight: 700, fontSize: 16 }}>
                            {remainingMinutes}:{remainingSeconds}
                        </Text>
                    </div>
                    <Progress
                        percent={gracePeriodProgress}
                        showInfo={false}
                        strokeColor={remainingGraceSeconds > 60 ? "#1677ff" : "#ff4d4f"}
                        trailColor="#e6f4ff"
                    />
                    <Text style={{ display: "block", marginTop: 10, color: "#8c8c8c" }}>
                        Déconnexion automatique après {Math.round(totalDurationMinutes)} minutes
                        d'inactivité au total.
                    </Text>
                </div>

                <div
                    style={{
                        borderRadius: 12,
                        padding: "12px 14px",
                        background: "linear-gradient(135deg, #e6f4ff 0%, #f0f5ff 100%)",
                        border: "1px solid #91caff",
                        color: "#003eb3",
                        fontSize: 13,
                        lineHeight: 1.6,
                    }}
                >
                    Votre travail en cours ne sera pas perdu par cette alerte, mais la
                    session sera clôturée si aucune confirmation n'est reçue avant la fin
                    du compte à rebours.
                </div>
            </div>
        </Modal>
    );
};

export default SessionTimeoutAlertModal;